import { SuretyAccountId, SuretyBondId, SuretyQuoteId } from "@inrev/common";
import { SuretyEntityIdMap } from "../types";
import { useCreateAgentFollower } from "./useCreateAgentFollower";
import { useFetchFollowers } from "./useFetchFollowers";
import { useRemoveAgentFollower } from "./useRemoveAgentFollower";

const accountFollowersRoot = (admin: boolean) => `/v2/${admin ? "admin/" : ""}surety/accounts`;

const useFollowerList = <T extends keyof SuretyEntityIdMap>(
	url: string,
	type: T,
	id: SuretyEntityIdMap[T],
) => {
	const fetchFollowersProps = useFetchFollowers(url, type, id);
	const createAgentFollowerProps = useCreateAgentFollower(url, type, id);
	const removeAgentFollowerProps = useRemoveAgentFollower(url, type, id);

	return {
		...fetchFollowersProps,
		...createAgentFollowerProps,
		...removeAgentFollowerProps,
	};
};

export const useAccountFollowers = (accountId: SuretyAccountId, admin = false) =>
	useFollowerList(`${accountFollowersRoot(admin)}/${accountId}/followers`, "accounts", accountId);

export const useQuoteFollowers = (
	accountId: SuretyAccountId,
	quoteId: SuretyQuoteId,
	admin = false,
) =>
	useFollowerList(
		`${accountFollowersRoot(admin)}/${accountId}/quotes/${quoteId}/followers`,
		"quotes",
		quoteId,
	);

export const useBondFollowers = (bondId: SuretyBondId, admin = false) =>
	useFollowerList(`/v2/${admin ? "admin/" : ""}surety/bonds/${bondId}/followers`, "bonds", bondId);
